import React, { useContext } from "react";
import { AppContext } from "../../../context";
import "./PricesFrom.css";
function PricesFrom({ store }) {
  const info = useContext(AppContext);

  return (
    <div className="ahp-store-card-price">
      <div className="ahp-store-card-price-text">{info.t("pricesFrom")}</div>
      <div className="ahp-store-card-price-value">
        {store.minimum_price * info.lodge.rooms} €
      </div>
      {store.type === "lodge" && (
        <div className="ahp-store-card-price-text">{info.t("perNight")}</div>
      )}
      {store.type === "restaurant" && (
        <div className="ahp-store-card-price-text">{info.t("perMenu")}</div>
      )}
    </div>
  );
}

export default PricesFrom;
